<template>
  <div>
    <Layout/>
    <h4>Pago</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPago" class="form-label">IdPago</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPago" name="idPago" v-model="datoPago.idPago" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFactura" class="form-label"> Factura</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFactura" name="idFactura" v-model="datoPago.idFactura">
                      <option v-for="factura in facturas" :value="factura.idFactura" :key="factura.idFactura">
                        {{ factura.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoPago.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoPago.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoPago.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFormaPago" class="form-label"> Forma Pago</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFormaPago" name="idFormaPago" v-model="datoPago.idFormaPago">
                      <option v-for="formaPago in formaPagos" :value="formaPago.idFormaPago" :key="formaPago.idFormaPago">
                        {{ formaPago.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaPago" class="form-label">FechaPago</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaPago" name="fechaPago" v-model="datoPago.fechaPago" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPago.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoPago.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoPago" class="form-label">EstadoPago</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="estadoPago" name="estadoPago" v-model="datoPago.estadoPago" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="monto" class="form-label">Monto</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="monto" name="monto" v-model="datoPago.monto" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="referencia" class="form-label">Referencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="referencia" name="referencia" v-model="datoPago.referencia" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPago" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPago" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPagoImg</th>
          <th scope="col">IdPago</th>
          <th scope="col">Imagen</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">Estado</th>
          <th scope="col">PagoFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pagoimg in datosPaginados" :key="pagoimg.idPagoImg">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(pagoimg.idPagoImg)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(pagoimg.idPagoImg)" title="Editar">edit_square</i></td>
          <td>{{pagoimg.idPagoImg}}</td>
          <td>{{pagoimg.idPago}}</td>
          <td><img :src="direccionImagen(pagoimg.idPago)" :style="estiloImagen"/></td>
          <td>{{pagoimg.nombre}}</td>
          <td>{{pagoimg.tipo}}</td>
          <td>{{pagoimg.estado}}</td>
          <td>{{getFormattedDate(pagoimg.pagoFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePago(pagoimg.idPagoImg)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPagoImg" class="form-label">IdPagoImg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPagoImg" name="idPagoImg" v-model="datoPagoImg.idPagoImg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPago" class="form-label">IdPago</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPago" name="idPago" v-model="datoPagoImg.idPago" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen" name="imagen" v-model="datoPagoImg.imagen" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoPagoImg.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tipo" name="tipo" v-model="datoPagoImg.tipo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPagoImg" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPagoImg" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      pagos : [],
      datoPago : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPago: '',
      facturas : [],
      formaPagos : [],
// Variables master
// Variables details
      pagoimgs : [],
      datoPagoImg : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPago = this.$route.params.p_idpago
    this.abrirEditar(this.p_idPago)
    this.getDataPagina(this.paginaActual)
    this.fetchFacturas()
    this.fetchFormaPagos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idFactura'
        ,'idFormaPago'
        ,'fechaPago'
        ,'estadoPago'
        ,'monto'
        ,'referencia'
      ];
      const requiredFieldsText = [
        'idFactura'
        ,'idEmpresa'
        ,'idFormaPago'
        ,'fechaPago'
        ,'estadoPago'
        ,'monto'
        ,'referencia'
      ];
      return validarForm(this.datoPago, requiredFields, requiredFieldsText);
    },
    async guardarPago(){
      if(this.validarForm() === 1){
        try {
          this.datoPago.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/pagos', this.datoPago)
          swal("Correcto!", "Pago creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPago(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pagos', this.datoPago)
          swal("Correcto!", "Pago creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPago={}
      this.titulo   = 'Crear Pago'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPago){
      this.modalWindow = true
      if(idPago != null){    
           api.get('/vwpagos/'+idPago).then(resp=>{
          this.datoPago = resp.data;
           });
      }
      this.titulo   = 'Editar Pago'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPago(){
      this.$router.push('/Pago')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.pagoimgs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwpagoimgs/nombre/'+this.nombreBusqueda).then(response=>{
          this.pagoimgs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.pagoimgs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwpagoimgs').then(response=>{
      this.pagoimgs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.pagoimgs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idFactura'
        ,'idFormaPago'
        ,'fechaPago'
        ,'estadoPago'
        ,'monto'
        ,'referencia'
      ];
      const requiredFieldsText = [
        'idFactura'
        ,'idEmpresa'
        ,'idFormaPago'
        ,'fechaPago'
        ,'estadoPago'
        ,'monto'
        ,'referencia'
      ];
      return validarForm(this.datoPago, requiredFields, requiredFieldsText);
    },
    async guardarPagoImg(){
      if(this.validarForm() === 1){
        try {
          this.datoPagoImg.idPago = this.datoPago.idPago;
          await api.post('/pagoimgs', this.datoPagoImg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PagoImg creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPagoImg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pagoimgs', this.datoPagoImg)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PagoImg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPagoImg={}
      this.titulo   = 'Crear Pago'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPagoImg){
      this.modalWindow = true
      if(idPagoImg != null){    
           api.get('/vwpagoimgs/'+idPagoImg).then(resp=>{
          this.datoPagoImg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Pago'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPagoImg){
      this.modalWindow = true
      if(idPagoImg != null){
        this.$router.push('/pagoimgmd/'+idPagoImg)
      }
    },
    async deletePagoImg (idPagoImg) {
      try{
        await api.delete('/pagoimgs/'+idPagoImg)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchFacturas() {
      fetch('http://localhost:8080/api/v1/facturas')
        .then(response => response.json())
        .then(data => {
          this.facturas = data;
        })
        .catch(error => {
          console.error('Error fetching facturas:', error);
        });
    },
    fetchFormaPagos() {
      fetch('http://localhost:8080/api/v1/formapagos')
        .then(response => response.json())
        .then(data => {
          this.formaPagos = data;
        })
        .catch(error => {
          console.error('Error fetching formaPagos:', error);
        });
    },
    fetchPagos() {
      fetch('http://localhost:8080/api/v1/pagos')
        .then(response => response.json())
        .then(data => {
          this.pagos = data;
        })
        .catch(error => {
          console.error('Error fetching pagos:', error);
        });
    },
  },
}
</script>
